import React from 'react';
import './Servicii.css'
import Navbar from '../components/Navbar';
import Footer from '../components/Footer';
import { IoCubeOutline } from "react-icons/io5";
import img from '../assests/bucatarie noua moderna.jpg'

// Iconuri simple SVG
const ConsultationIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M20 4C23.3137 4 26 6.68629 26 10C26 13.3137 23.3137 16 20 16C16.6863 16 14 13.3137 14 10C14 6.68629 16.6863 4 20 4Z" fill="currentColor"/>
    <path d="M8 32C8 24.268 14.268 18 22 18H18C10.268 18 4 24.268 4 32V36H36V32C36 24.268 29.732 18 22 18H18Z" fill="currentColor"/>
  </svg>
);

const MeasurementIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="8" width="32" height="24" rx="2" stroke="currentColor" strokeWidth="2" fill="none"/>
    <line x1="8" y1="16" x2="32" y2="16" stroke="currentColor" strokeWidth="2"/>
    <line x1="8" y1="24" x2="32" y2="24" stroke="currentColor" strokeWidth="2"/>
    <line x1="16" y1="12" x2="16" y2="28" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const MobileDesignIcon = () => (
  <span ><IoCubeOutline style={{width:'80px', height:'40px'}} /></span>
);

const ProductionIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="12" width="32" height="20" rx="2" stroke="currentColor" strokeWidth="2" fill="none"/>
    <rect x="8" y="16" width="6" height="4" fill="currentColor"/>
    <rect x="16" y="16" width="6" height="4" fill="currentColor"/>
    <rect x="24" y="16" width="6" height="4" fill="currentColor"/>
    <line x1="12" y1="8" x2="12" y2="12" stroke="currentColor" strokeWidth="2"/>
    <line x1="20" y1="8" x2="20" y2="12" stroke="currentColor" strokeWidth="2"/>
    <line x1="28" y1="8" x2="28" y2="12" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const DeliveryIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <rect x="4" y="12" width="20" height="16" rx="2" stroke="currentColor" strokeWidth="2" fill="none"/>
    <path d="M24 20h8l4 4v8h-4" stroke="currentColor" strokeWidth="2" fill="none"/>
    <circle cx="12" cy="32" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
    <circle cx="32" cy="32" r="4" stroke="currentColor" strokeWidth="2" fill="none"/>
    <line x1="8" y1="8" x2="8" y2="12" stroke="currentColor" strokeWidth="2"/>
    <line x1="16" y1="8" x2="16" y2="12" stroke="currentColor" strokeWidth="2"/>
  </svg>
);

const SupportIcon = () => (
  <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M36 20C36 28.837 28.837 36 20 36C11.163 36 4 28.837 4 20C4 11.163 11.163 4 20 4C28.837 4 36 11.163 36 20Z" stroke="currentColor" strokeWidth="2" fill="none"/>
    <path d="M14 14C14 14 16 12 20 12C24 12 26 14 26 14" stroke="currentColor" strokeWidth="2"/>
    <path d="M14 26C14 26 16 28 20 28C24 28 26 26 26 26" stroke="currentColor" strokeWidth="2"/>
    <circle cx="20" cy="20" r="2" fill="currentColor"/>
  </svg>
);

const HeroSection = () => {
  return (
    <section className="hero-section">
      <div className="hero-content">
        <h1>Mobilier Personalizat la Comandă – De la Design la Montaj</h1>
        <p>De la concept și design până la producție și montaj, îți oferim servicii complete de mobilier personalizat și mobilier la comandă, create pentru a transforma orice spațiu într-un loc unic și funcțional.</p>
      </div>
    </section>
  );
};

const HeroSection1 = () => {
  return (
    <section className="hero-section1">
      <div className="hero-content1">
        <h1>Mobilier la Comandă – Design Unic pentru Spațiul Tău</h1>
        <p>Oferim servicii complete de mobilier la comandă în Bucuresti – de la concept și proiectare 3D, până la producție și montaj profesional, adaptate perfect spațiului și stilului tău.</p>
      </div>
    </section>
  );
};

const FurnitureHero = () => {
  return (
    <section className="furniture-hero">
      <div className="hero-container">
        {/* Text Section - Left Side */}
        <div className="hero-text-section">
          <h1 className="hero-title">
            Mobilier la comandă – transformăm ideile tale în realitate
          </h1>
          <p className="hero-description">
            Cu peste 20 de ani de experiență în producția de mobilier personalizat, aducem mobilierul de vis direct la tine acasă.
             Realizăm mobilă la comandă pentru bucătării, livinguri, dormitoare, dressing-uri și spații comerciale, atât în București,
              cât și în toată țara.
          </p>
          <p className="hero-details">
            Oferim design 3D fotorealist, materiale premium, execuție impecabilă și montaj profesionist.
             Indiferent dacă îți dorești un dressing modern, o bucătărie pe măsură sau mobilier pentru biroul tău,
              îți garantăm calitate superioară și un stil adaptat nevoilor tale.
          </p>
        </div>

        {/* Image Section with Overlaid Features - Right Side */}
        <div className="hero-image-section">
          {/* Kitchen Image Background */}
          <img src={img} alt="" srcset="" />

          {/* Features Cards Overlaid on Image */}
          <div className="features-overlay">
            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M12 2L13.09 8.26L19 9L13.09 9.74L12 16L10.91 9.74L5 9L10.91 8.26L12 2Z" fill="currentColor"/>
                </svg>
              </div>
              <h2 className="feature-title">Soluții de mobilier personalizat și idei adaptate spațiului tău</h2>
              <p className="feature-description">
                Fiecare locuință are propria poveste. Noi o completăm cu mobilier la comandă, creativitate și propuneri adaptate stilului și nevoilor tale.
              </p>
            </div>

            <div className="feature-card">
              <div className="feature-icon">
                <svg viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
                  <path d="M3 5V19C3 20.1 3.9 21 5 21H19C20.1 21 21 20.1 21 19V5C21 3.9 20.1 3 19 3H5C3.9 3 3 3.9 3 5ZM5 5H19V19H5V5Z" fill="currentColor"/>
                  <rect x="7" y="7" width="4" height="4" fill="currentColor"/>
                  <rect x="13" y="7" width="4" height="4" fill="currentColor"/>
                  <rect x="7" y="13" width="10" height="4" fill="currentColor"/>
                </svg>
              </div>
              <h2 className="feature-title">Materiale premium pentru mobilă de calitate</h2>
              <p className="feature-description">
                Folosim doar materiale exclusiviste, atent selecționate pentru durabilitate, estetică și confort, astfel încât fiecare piesă să reziste în timp și să impresioneze vizual.
              </p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const ServicesGrid = () => {
  const services = [
    {
      icon: <ConsultationIcon />,
      title: "Consultanță gratuită",
      description: "Îți oferim sfaturi personalizate pentru a-ți găsi stilul și soluția care ți se potrivește.",
    },
    {
      icon: <MeasurementIcon />,
      title: "Măsurători profesionale",
      description: "Venim să facem măsurători pentru măsurători exacte ca totul să se îmbine perfect.",
    },
    {
      icon: <MobileDesignIcon />,
      title: "Design Interior 3D",
      description: "Îți creăm mobilierul în format 3D realist, ca să știi exact cum va arăta.",
    },
    {
      icon: <ProductionIcon />,
      title: "Producție la comandă",
      description: "Realizăm mobilierul exact cum dorești, cu materiale și finisaje premium.",
    },
    {
      icon: <DeliveryIcon />,
      title: "Livrare și montaj",
      description: "Ne ocupăm de tot - livrăm în siguranță mobilierul cu grijă direct la tine acasă.",
    },
    {
      icon: <SupportIcon />,
      title: "Garanție și suport",
      description: "Ai garanție și suport complet pentru mobilier fără griji ani la rând.",
    }
  ];

  return (
    <section className="services-grid">
      <div className="container">
        <div className="services-cards">
          {services.map((service, index) => (
            <div key={index} className="service-card">
              <div className="service-icon">
                {service.icon}
              </div>
              <h3>{service.title}</h3>
              <p>{service.description}</p>
              {/* <button className="service-button">
                {service.buttonText}
                <span className="arrow">→</span>
              </button> */}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

const BottomCTA = () => {
  return (
    <section className="bottom-cta">
      <div className="cta-content">
        <div className="cta-text">
          <h2>Nu știi de unde să începi?</h2>
          <p>Hai să discutăm despre proiectul tău!</p>
        </div>
        <button className="cta-button">
          <a style={{color:'white', textDecoration:'none'}} href="tel:+40729981434">Solicită ofertă
          <span className="arrow">→</span></a>
        </button>
      </div>
    </section>
  );
};

const Servicii = () => {
  return (
    <div className="app">
      <Navbar />
      <HeroSection />
      <ServicesGrid />
      <FurnitureHero />
      <HeroSection1 />
      <BottomCTA />
      <Footer />
    </div>
  );
};

export default Servicii;